var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.productFlag != 4
    ? _c("div", { attrs: { id: "box" } }, [
        _c(
          "div",
          {
            staticClass: "course_content",
            style: "height:" + (_vm.windowHeight - 235) + "px"
          },
          [
            _c("div", { staticClass: "course_left" }, [
              _vm._m(0),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "course_tree" },
                [
                  _c("el-tree", {
                    ref: "vuetree",
                    attrs: {
                      data: _vm.data,
                      props: _vm.defaultProps,
                      "node-key": "id",
                      "default-expanded-keys": _vm.expendId,
                      "highlight-current": true
                    },
                    on: { "node-click": _vm.handleNodeClick },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(ref) {
                            var node = ref.node
                            return _c(
                              "span",
                              { staticClass: "span-ellipsis" },
                              [
                                _c("span", { attrs: { title: node.label } }, [
                                  _vm._v(_vm._s(node.label))
                                ])
                              ]
                            )
                          }
                        }
                      ],
                      null,
                      false,
                      2980223913
                    )
                  })
                ],
                1
              )
            ]),
            _vm._v(" "),
            _vm.data && _vm.data.length > 0
              ? _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "loading",
                        rawName: "v-loading",
                        value: _vm.loading,
                        expression: "loading"
                      }
                    ],
                    staticClass: "course_main"
                  },
                  [
                    _c("miniSwiper", { attrs: { sign: "preview" } }),
                    _vm._v(" "),
                    !(_vm.listItem === null)
                      ? _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.showMain,
                                expression: "showMain"
                              }
                            ],
                            staticClass: "show_main"
                          },
                          [
                            _c("h2", { staticClass: "title" }, [
                              _vm.listItem.testPaper === null
                                ? _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.listItem.resourceType === 3
                                          ? "试题"
                                          : _vm.listItem.name
                                      )
                                    )
                                  ])
                                : _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.listItem.resourceType === 3
                                          ? "试题"
                                          : _vm.listItem.name +
                                              "(" +
                                              _vm.listItem.testPaper
                                                .paperScore +
                                              "分" +
                                              "/" +
                                              _vm.listItem.testPaper.count +
                                              "题" +
                                              ")"
                                      )
                                    )
                                  ])
                            ]),
                            _vm._v(" "),
                            _vm.listItem.type == 1
                              ? _c("div", { staticClass: "img_wrap" }, [
                                  _c(
                                    "div",
                                    {
                                      style: {
                                        transform:
                                          "scale(" + _vm.multiples + ")",
                                        transformOrigin: "top left"
                                      }
                                    },
                                    [
                                      _c(
                                        "viewer",
                                        {
                                          attrs: {
                                            images: [_vm.listItem.newAttaUrl]
                                          }
                                        },
                                        _vm._l(
                                          [_vm.listItem.newAttaUrl],
                                          function(src, i) {
                                            return _c("img", {
                                              key: i,
                                              attrs: { src: src }
                                            })
                                          }
                                        ),
                                        0
                                      )
                                    ],
                                    1
                                  )
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.listItem.type == 2
                              ? _c(
                                  "div",
                                  {
                                    class:
                                      "pdf_wrap " +
                                      _vm.pdfEnlargStyle +
                                      " " +
                                      _vm.pageStyle,
                                    on: { dblclick: _vm.pdfdblclick }
                                  },
                                  [
                                    _c("pdf", {
                                      ref: "pdf",
                                      staticStyle: {
                                        width: "99%",
                                        margin: "auto"
                                      },
                                      attrs: {
                                        src: _vm.listItem.newAttaUrl,
                                        page: _vm.pageNum,
                                        rotate: _vm.pageRotate
                                      },
                                      on: {
                                        progress: function($event) {
                                          _vm.loadedRatio = $event
                                        },
                                        "num-pages": function($event) {
                                          _vm.pageTotalNum = $event
                                        },
                                        "link-clicked": function($event) {
                                          _vm.page = $event
                                        },
                                        loaded: _vm.loadPdfHandler
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("i", {
                                      staticClass:
                                        "el-icon-arrow-left btn-def btn-pre",
                                      on: {
                                        dblclick: function($event) {
                                          $event.stopPropagation()
                                        },
                                        click: function($event) {
                                          $event.stopPropagation()
                                          return _vm.prePage.apply(
                                            null,
                                            arguments
                                          )
                                        }
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("i", {
                                      staticClass:
                                        "el-icon-arrow-right btn-def btn-next",
                                      on: {
                                        dblclick: function($event) {
                                          $event.stopPropagation()
                                        },
                                        click: function($event) {
                                          $event.stopPropagation()
                                          return _vm.nextPage.apply(
                                            null,
                                            arguments
                                          )
                                        }
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      { staticClass: "pdfCurrentPage" },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.pageNum) +
                                            "/" +
                                            _vm._s(_vm.pageTotalNum)
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "operating_btn" },
                                      [
                                        _c("div", [
                                          _c("i", {
                                            staticClass: "el-icon-refresh-left",
                                            on: {
                                              click: _vm.counterClock,
                                              dblclick: function($event) {
                                                $event.stopPropagation()
                                              }
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("i", {
                                            staticClass:
                                              "el-icon-refresh-right",
                                            on: {
                                              click: _vm.clock,
                                              dblclick: function($event) {
                                                $event.stopPropagation()
                                              }
                                            }
                                          })
                                        ])
                                      ]
                                    )
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.listItem.type == 3
                              ? _c("audio", {
                                  ref: "audioC",
                                  attrs: {
                                    src: _vm.listItem.newAttaUrl,
                                    controls: "controls"
                                  }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.listItem.type == 4
                              ? _c(
                                  "video",
                                  {
                                    ref: "videoC",
                                    staticClass: "video-js",
                                    staticStyle: { margin: "auto" },
                                    attrs: {
                                      id: "video1",
                                      controls: "",
                                      controlsList: "nodownload",
                                      preload: "auto",
                                      width: "90%",
                                      height: _vm.windowHeight - 360 + "px",
                                      "data-setup": '{"example_option":true}'
                                    }
                                  },
                                  [
                                    _c("source", {
                                      attrs: {
                                        id: "sourceBox",
                                        src: _vm.listItem.newAttaUrl,
                                        type: "video/mp4"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("p", { staticClass: "vjs-no-js" }, [
                                      _vm._v("不支持播放")
                                    ])
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.listItem.type == 5
                              ? _c("div", { staticClass: "zip_wrap" }, [
                                  _vm.isZip
                                    ? _c("iframe", {
                                        attrs: {
                                          width: "100%",
                                          height: "100%",
                                          src: _vm.listItem.newAttaUrl,
                                          frameborder: "0"
                                        }
                                      })
                                    : _c("div", [
                                        _c("p", [_vm._v("该文件无法预览")])
                                      ])
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.listItem.resourceType == 3
                              ? _c("div", { staticClass: "zip_wrap" }, [
                                  _c("div", {
                                    staticClass: "editorShowArea ql-editor",
                                    domProps: {
                                      innerHTML: _vm._s(_vm.listItem.content)
                                    }
                                  })
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.listItem.resourceType == 5
                              ? _c("div", { staticClass: "test_wrap" }, [
                                  _c(
                                    "ul",
                                    _vm._l(
                                      _vm.listItem.testPaper.sections,
                                      function(item, key) {
                                        return _c("li", { key: key }, [
                                          _c("h3", [
                                            _vm._v(
                                              _vm._s(
                                                item.sectionAlias ||
                                                  item.sectionName
                                              )
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("p", [
                                            _vm._v(
                                              _vm._s(item.sectionScore) +
                                                "分 / " +
                                                _vm._s(item.questionCount) +
                                                "题"
                                            )
                                          ]),
                                          _vm._v(" "),
                                          item.sectionName == "单选题"
                                            ? _c("img", {
                                                attrs: {
                                                  src: require("../../../../../static/images/study/radio.png")
                                                }
                                              })
                                            : _vm._e(),
                                          _vm._v(" "),
                                          item.sectionName == "多选题"
                                            ? _c("img", {
                                                attrs: {
                                                  src: require("../../../../../static/images/study/checkbox.png")
                                                }
                                              })
                                            : _vm._e(),
                                          _vm._v(" "),
                                          item.sectionName == "判断题"
                                            ? _c("img", {
                                                attrs: {
                                                  src: require("../../../../../static/images/study/judge.png")
                                                }
                                              })
                                            : _vm._e(),
                                          _vm._v(" "),
                                          item.sectionName == "实操题"
                                            ? _c("img", {
                                                attrs: {
                                                  src: require("../../../../../static/images/study/operation.png")
                                                }
                                              })
                                            : _vm._e()
                                        ])
                                      }
                                    ),
                                    0
                                  )
                                ])
                              : _vm._e()
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !_vm.showMain,
                            expression: "!showMain"
                          }
                        ],
                        staticClass: "no_main"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: require("../../../../../static/images/wujieguo.png"),
                            alt: ""
                          }
                        }),
                        _vm._v(" "),
                        _c("p", [_vm._v("本节无内容，请选择其他章节")])
                      ]
                    )
                  ],
                  1
                )
              : _c(
                  "div",
                  {
                    staticClass: "course_main",
                    staticStyle: { "text-align": "center" }
                  },
                  [
                    _c("img", {
                      staticStyle: { width: "200px", "margin-top": "10%" },
                      attrs: {
                        src: require("../../../../../static/images/wujieguo.png"),
                        alt: ""
                      }
                    }),
                    _vm._v(" "),
                    _c("p", { staticStyle: { "margin-top": "15px" } }, [
                      _vm._v("暂无内容")
                    ])
                  ]
                )
          ]
        )
      ])
    : _c(
        "div",
        {
          staticClass: "task_list_preview",
          style: "height:" + (_vm.windowHeight - 238) + "px"
        },
        [
          _c("div", { staticClass: "cc_title" }, [
            _c(
              "div",
              { staticClass: "cc_search" },
              [
                _c(
                  "el-form",
                  {
                    ref: "ruleForm",
                    staticClass: "demo-ruleForm",
                    attrs: { model: _vm.ruleForm, "status-icon": "" }
                  },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { prop: "name" } },
                      [
                        _c("el-input", {
                          attrs: {
                            type: "text",
                            autocomplete: "off",
                            placeholder: "请输入任务名称"
                          },
                          model: {
                            value: _vm.ruleForm.name,
                            callback: function($$v) {
                              _vm.$set(_vm.ruleForm, "name", $$v)
                            },
                            expression: "ruleForm.name"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { staticClass: "taskType", attrs: { prop: "taskType" } },
                      [
                        _c(
                          "el-select",
                          {
                            attrs: {
                              placeholder: "请选择任务类型",
                              clearable: ""
                            },
                            model: {
                              value: _vm.ruleForm.taskType,
                              callback: function($$v) {
                                _vm.$set(_vm.ruleForm, "taskType", $$v)
                              },
                              expression: "ruleForm.taskType"
                            }
                          },
                          _vm._l(_vm.taskTypeList, function(item) {
                            return _c("el-option", {
                              key: item.id,
                              attrs: { label: item.name, value: item.id }
                            })
                          }),
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { staticClass: "company", attrs: { prop: "company" } },
                      [
                        _c(
                          "el-select",
                          {
                            attrs: {
                              placeholder: "请选择所属公司",
                              clearable: ""
                            },
                            model: {
                              value: _vm.ruleForm.company,
                              callback: function($$v) {
                                _vm.$set(_vm.ruleForm, "company", $$v)
                              },
                              expression: "ruleForm.company"
                            }
                          },
                          _vm._l(_vm.companyList, function(item) {
                            return _c("el-option", {
                              key: item.id,
                              attrs: { label: item.name, value: item.id }
                            })
                          }),
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "search_btn" },
                      [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "primary" },
                            on: { click: _vm.getTaskList }
                          },
                          [_vm._v("查询")]
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "cc_content",
              style: "height:" + (_vm.windowHeight - 338) + "px"
            },
            [
              _vm._m(1),
              _vm._v(" "),
              _vm.realTaskList.length > 0
                ? _c(
                    "ul",
                    _vm._l(_vm.realTaskList, function(item, key) {
                      return _c(
                        "li",
                        { key: key, attrs: { "data-key": item.id } },
                        [
                          _c("div", { staticClass: "select_box" }, [
                            _vm._v(
                              "\n          " + _vm._s(key + 1) + "\n        "
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "title_box" }, [
                            _vm._v(_vm._s(item.taskName))
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "type_box" }, [
                            _vm._v(_vm._s(item.taskFlowName))
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "company_box" }, [
                            _vm._v(_vm._s(item.companyName))
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "createTime_box" }, [
                            _vm._v(_vm._s(item.createTime))
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "pushTime_box" }, [
                            _vm._v(_vm._s(item.doTaskTime))
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "operation_box" }, [
                            _c("span", {
                              staticClass: "preview_task",
                              attrs: { title: "预览" },
                              on: {
                                click: function($event) {
                                  return _vm.previewTask(item)
                                }
                              }
                            })
                          ])
                        ]
                      )
                    }),
                    0
                  )
                : _c("div", { staticClass: "no_task" }, [
                    _c("img", {
                      attrs: {
                        src: require("../../../../../static/images/wujieguo.png"),
                        alt: ""
                      }
                    }),
                    _vm._v(" "),
                    _c("p", [_vm._v("暂无任务")])
                  ])
            ]
          ),
          _vm._v(" "),
          _vm.realTaskList.length
            ? _c("Pagination", {
                attrs: {
                  currentpage: _vm.pageTotal.currentPage,
                  limit: _vm.pageTotal.pageSize,
                  total: _vm.pageTotal.total,
                  layout: "sizes, prev, pager, next, jumper",
                  small: true
                },
                on: {
                  handleCurrentChange: _vm.handleCurrentChange,
                  handleSizeChange: _vm.handleSizeChange
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _c(
            "el-drawer",
            {
              attrs: {
                visible: _vm.previewTaskShow,
                direction: _vm.direction,
                size: "80%",
                "with-header": false,
                "close-on-press-escape": false
              },
              on: {
                "update:visible": function($event) {
                  _vm.previewTaskShow = $event
                }
              }
            },
            [
              _c("div", { staticClass: "preview_task_wrap" }, [
                _c("h2", { staticClass: "preview_task_title" }, [
                  _vm._v(_vm._s(_vm.previewTaskData.title))
                ]),
                _vm._v(" "),
                _c("img", {
                  staticClass: "preview_task_close",
                  attrs: {
                    src: require("../../../../../static/images/close.png")
                  },
                  on: {
                    click: function($event) {
                      _vm.previewTaskShow = false
                    }
                  }
                }),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "preview_task_content",
                    style: "height:" + (_vm.windowHeight - 60) + "px"
                  },
                  [
                    _c("div", {
                      domProps: {
                        innerHTML: _vm._s(_vm.previewTaskData.content)
                      }
                    }),
                    _vm._v(" "),
                    _vm.previewTaskData.attachmentList.length > 0
                      ? _c("p", { staticClass: "attachment_title" }, [
                          _vm._v("附件列表：")
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.previewTaskData.attachmentList.length > 0
                      ? _c(
                          "ul",
                          { staticClass: "attachment_list" },
                          _vm._l(_vm.previewTaskData.attachmentList, function(
                            val
                          ) {
                            return _c("li", { key: val.id }, [
                              _c("i", { staticClass: "el-icon-document" }),
                              _vm._v(" "),
                              _c("span", [_vm._v(_vm._s(val.name))])
                            ])
                          }),
                          0
                        )
                      : _vm._e()
                  ]
                )
              ])
            ]
          )
        ],
        1
      )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "study_progress" }, [
      _c("div", { staticClass: "study_task_statistics" }, [
        _c("p", [_vm._v("课程预览")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "source_table_title" }, [
      _c("p", [_vm._v("序号")]),
      _vm._v(" "),
      _c("p", [_vm._v("任务名称")]),
      _vm._v(" "),
      _c("p", [_vm._v("任务类型")]),
      _vm._v(" "),
      _c("p", [_vm._v("所属公司")]),
      _vm._v(" "),
      _c("p", [_vm._v("创建时间")]),
      _vm._v(" "),
      _c("p", [_vm._v("推送时间")]),
      _vm._v(" "),
      _c("p", [_vm._v("操作")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5d4b6fe0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5d4b6fe0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/TeachClass/components/courseContent.vue
// module id = null
// module chunks = 